var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import config from '@/config';
import api from '@/shared/api';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { useEffect } from 'react';
import moment from 'moment';
import { IntraCompanyQueryKey } from './queryKey';
export var useGetIntraCompanyOverview = function (filters) {
    var intl = useIntl();
    var queryClient = useQueryClient();
    // const [data,setData]=useState();
    var _a = useQuery([IntraCompanyQueryKey.Overview], function (_a) {
        var signal = _a.signal;
        return api.base
            .get("".concat(config.appUrls.api, "/api/IntraCompany"), {
            params: __assign(__assign({}, filters), { dateFrom: filters.dateFrom ? moment(filters.dateFrom).toISOString() : null, dateUntil: filters.dateUntil ? moment(filters.dateUntil).toISOString() : null }),
            signal: signal,
        })
            .then(function (res) {
            var _a;
            return (_a = res.data) === null || _a === void 0 ? void 0 : _a.map(function (x) {
                return (__assign(__assign({}, x), { key: "".concat(x.relationCompanyId, ";").concat(x.userCompanyId) }));
            });
        });
    }, {
        enabled: true,
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    }), data = _a.data, isLoading = _a.isLoading, error = _a.error, refetch = _a.refetch;
    var reload = function () {
        var detailsQueryKey = [IntraCompanyQueryKey.Details];
        var queryKey = [IntraCompanyQueryKey.Overview];
        queryClient.cancelQueries(queryKey);
        queryClient.removeQueries({ queryKey: queryKey });
        queryClient.cancelQueries(detailsQueryKey);
        queryClient.removeQueries({ queryKey: detailsQueryKey });
        return refetch();
    };
    var setIsProcessing = function (keys, isProcessing) {
        if (isProcessing === void 0) { isProcessing = true; }
        queryClient.setQueriesData([IntraCompanyQueryKey.Overview], function (oldData) {
            return oldData.map(function (x) { return (keys.includes(x.key) ? __assign(__assign({}, x), { isProcessing: isProcessing }) : x); });
        });
    };
    // Reload if filters change
    useEffect(function () {
        reload();
    }, [filters]);
    return {
        data: data,
        error: error,
        isLoading: isLoading,
        reload: reload,
        setIsProcessing: setIsProcessing,
    };
};
